export default __webpack_public_path__ + "static/media/thailand.0511203d.jpg";